// Single source of truth for which rooms may receive a Room Service / KOT food
// order (Bug 8720). A room is serviceable only when an in-house guest occupies
// it AND it is not under maintenance (blocked / out-of-order).
//
// Housekeeping state (e.g. DIRTY) does NOT affect serviceability — a guest in a
// dirty room can still order food. Only an OCCUPIED, non-blocked room qualifies;
// vacant / reserved (no in-house guest) and blocked / out-of-order rooms are out.
//
// Used by every order-creation room list so the rule can't drift between the KOT
// outlet flow (KOTModule) and the Bar outlet flow (Orders).

// maintenance_status values that take a room out of service.
export const BLOCKED_MAINTENANCE_STATUSES = ['BLOCKED', 'OUT_OF_ORDER', 'OOO', 'OOS', 'MAINTENANCE'];

// True when the room is under maintenance and therefore not serviceable.
export function isRoomBlocked(room) {
  const maint = String(room?.maintenance_status || '').toUpperCase().trim();
  return !!maint && BLOCKED_MAINTENANCE_STATUSES.includes(maint);
}

// True when an in-house guest currently occupies the room. Accepts both the
// room-rack/live shape (occupancy_status / stay_status) and any normalised shape
// that exposes status / is_occupied.
export function isRoomOccupied(room) {
  if (!room) return false;
  return room.occupancy_status === 'OCCUPIED'
    || room.stay_status === 'CHECKED_IN'
    || room.status === 'OCCUPIED'
    || room.status === 'CHECKED_IN'
    || room.is_occupied === true;
}

// The serviceability rule: occupied AND not blocked/out-of-order.
export function isRoomServiceEligible(room) {
  if (!isRoomOccupied(room)) return false;
  if (isRoomBlocked(room)) return false;
  return true;
}
